import styled from 'styled-components';

// Components
import InputText from '../../../inputs/InputText';
import { InputTextArea } from '../../../inputs/InputTextArea';
import { SpecialTag } from '../../SpecialTag';

// Types
import { Area } from '../../../inputs/InputTextArea/styles';

export const ContainerOT = styled.div`
  background-color: ${({ theme }) => theme.colors.backgroundLila};
  border-radius: 1rem;
  padding: ${({ theme }) => theme.spacing.xl};
`;

export const ContainerHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  padding: 0 0 ${({ theme }) => theme.spacing.l};
`;

export const ContainerContent = styled.form`
  display: flex;
  position: relative;
  gap: 3.2rem;

  @media (max-width: ${({ theme }) =>
      theme.breakPoints.landscapeTablet * theme.percentBaseResponsive}rem) {
    flex-direction: column;
  }
`;

export const ContainerDescription = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  gap: 3.2rem;

  @media (max-width: ${({ theme }) =>
      theme.breakPoints.portraitTablet * theme.percentBaseResponsive}rem) {
    gap: 2rem;
  }
`;

export const PkInputsContainer = styled.div`
  display: flex;
  gap: 3.2rem;
  flex-wrap: wrap;

  @media (max-width: ${({ theme }) =>
      theme.breakPoints.portraitTablet * theme.percentBaseResponsive}rem) {
    gap: 2rem;
    width: 100%;
  }
`;

export const InputPKInit = styled(InputText)`
  max-width: 16rem;

  @media (max-width: ${({ theme }) =>
      theme.breakPoints.portraitTablet * theme.percentBaseResponsive}rem) {
    flex: 1;
    min-width: 0;
  }
`;

export const InputPKEnd = styled(InputText)`
  max-width: 16rem;

  @media (max-width: ${({ theme }) =>
      theme.breakPoints.portraitTablet * theme.percentBaseResponsive}rem) {
    flex: 1;
    min-width: 0;
  }
`;

export const InputDescription = styled(InputTextArea)`
  width: 100%;
  @media (max-width: ${({ theme }) =>
      theme.breakPoints.landscapeTablet * theme.percentBaseResponsive}rem) {
    ${Area} {
      min-height: 21rem;
    }
  }
`;

export const StyledSpecialTag = styled(SpecialTag)`
  cursor: pointer;
`;
